/*
 * Cart drawer helpers:
 * 1) While the drawer is open, hide floating UI that would otherwise cover the
 *    Checkout button: the Gorgias live-chat launcher AND our wishlist floating
 *    button (+ its toast). Restored when the drawer closes.
 * 2) Track the VISUAL viewport height into the --ar-cart-vh CSS variable, so the
 *    mobile drawer can size itself to the space ABOVE the on-screen keyboard.
 *    Without this, focusing the discount-code / note field opens the keyboard
 *    and pushes the pinned cart summary out of view (the cart "disappears").
 *
 * The /cart PAGE keeps the chat off separately (see cart-page-offers.js), since
 * the drawer -- and therefore this script -- is not rendered on that page.
 */
(function () {
  function overlayEls() {
    var els = [];
    var container = document.getElementById('gorgias-chat-container');
    if (container) els.push(container);
    document.querySelectorAll('[class*="gorgias-chat-key"]').forEach(function (el) {
      els.push(el);
    });
    var fab = document.getElementById('ar-wl-fab');
    if (fab) els.push(fab);
    var toast = document.getElementById('ar-wl-toast');
    if (toast) els.push(toast);
    return els;
  }

  function setHidden(hidden) {
    overlayEls().forEach(function (el) {
      if (hidden) {
        el.style.setProperty('display', 'none', 'important');
      } else {
        el.style.removeProperty('display');
      }
    });
  }

  function updateVH() {
    var vv = window.visualViewport;
    var h = vv ? vv.height : window.innerHeight;
    document.documentElement.style.setProperty('--ar-cart-vh', Math.round(h) + 'px');
  }

  function init() {
    updateVH();
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateVH);
      window.visualViewport.addEventListener('scroll', updateVH);
    }
    window.addEventListener('resize', updateVH);
    window.addEventListener('orientationchange', updateVH);

    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var sync = function () { setHidden(drawer.classList.contains('is-visible')); };
    new MutationObserver(sync).observe(drawer, {
      attributes: true,
      attributeFilter: ['class']
    });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();